import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMainContext } from "../../../Context";
import { landingData } from "../../../Utils/Apis";

export const useHome = () => {
  const [data, setData] = useState({});
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);
  const { post } = useMainContext();
  const navigate = useNavigate();
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(landingData);
    if (+status == 200) {
      setData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return {
    data,
    loading,
    form,
    setForm,
    navigate,
  };
};
